export default __webpack_public_path__ + "static/media/barcelona.10b5b5d2.jpg";